// ABOUTME: Main navigation component with authentication integration and responsive design
// ABOUTME: Provides consistent navigation across all pages with login/logout functionality

import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { UserMenu } from './auth/UserMenu';
import { useAuth } from '../contexts/AuthContext';

export const Navigation: React.FC = () => {
  const { user, isAdmin, signIn } = useAuth();

  return (
    <nav className="border-b bg-background">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center space-x-4">
            <Link to="/" className="text-xl font-bold text-primary">
              PhotoStream
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            {user ? (
              <>
                {isAdmin && (
                  <Button variant="outline" size="sm" asChild>
                    <Link to="/admin">Create Gallery</Link>
                  </Button>
                )}
                <UserMenu />
              </>
            ) : (
              <Button onClick={signIn} size="sm">
                Sign In
              </Button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
